// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"t5-z"};